// Compare two objects to see if they are equal
export const areObjectsEqual = (
  obj1: Record<string, any>,
  obj2: Record<string, any>,
) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};
